/* ==================================================
   STUDIO SOLIVEN — Global JavaScript
   ================================================== */

(function () {
  'use strict';

  const SS = window.StudioSoliven = {};

  /* ================================================
     NOTIFICATION BAR
     ================================================ */
    SS.NotificationBar = {
    init() {
      const bar = document.querySelector('.notification-bar');
      if (!bar) {
        document.body.classList.add('no-notification-bar');
        return;
      }

      const dismissBtn = bar.querySelector('.notification-bar__dismiss');
      const storageKey = 'ss-notification-dismissed';
      const barId = bar.dataset.barId || 'default';

      if (sessionStorage.getItem(storageKey) === barId) {
        bar.classList.add('is-dismissed');
        document.body.classList.remove('has-notification-bar');
        document.body.classList.add('no-notification-bar');
        return;
      }

      document.body.classList.add('has-notification-bar');
      document.body.classList.remove('no-notification-bar');

      if (dismissBtn) {
        dismissBtn.addEventListener('click', function() {
          bar.classList.add('is-dismissed');
          document.body.classList.remove('has-notification-bar');
          document.body.classList.add('no-notification-bar');
          sessionStorage.setItem(storageKey, barId);
        });
      }
    }
  };

  /* ================================================
     MOBILE MENU
     ================================================ */
  SS.MobileMenu = {
    init() {
      const toggle = document.querySelector('.header__menu-toggle');
      const drawer = document.querySelector('.mobile-nav');
      const closeBtn = document.querySelector('.mobile-nav__close');
      const overlay = document.querySelector('.overlay--menu');
      const headerSection = document.getElementById('shopify-section-header');

      if (!toggle || !drawer) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.classList.add('is-active');
        document.body.classList.add('overflow-hidden');
        toggle.setAttribute('aria-expanded', 'true');

        /* Elevate header section above overlay (JS fallback for CSS :has) */
        if (headerSection) headerSection.style.zIndex = '310';

        var firstLink = drawer.querySelector('.mobile-nav__link');
        if (firstLink) firstLink.focus();
      });

      function closeMenu() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) overlay.classList.remove('is-active');
        document.body.classList.remove('overflow-hidden');
        toggle.setAttribute('aria-expanded', 'false');

        /* Reset z-index */
        if (headerSection) headerSection.style.zIndex = '';

        toggle.focus();
      }

      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      if (overlay) overlay.addEventListener('click', closeMenu);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeMenu();
        }
      });
    }
  };

  /* ================================================
     SEARCH DRAWER
     ================================================ */
  SS.SearchDrawer = {
    init() {
      const openBtn = document.querySelector('.header__search-toggle');
      const drawer = document.querySelector('.search-drawer');
      const closeBtn = document.querySelector('.search-drawer__close');
      const input = document.querySelector('.search-drawer__input');

      if (!openBtn || !drawer) return;

      // Ensure closed on load
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (input) {
          setTimeout(function() { input.focus(); }, 150);
        }
      });

      function closeSearch() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openBtn.focus();
      }

      if (closeBtn) closeBtn.addEventListener('click', closeSearch);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeSearch();
        }
      });
    }
  };

  /* ================================================
     CART DRAWER
     ================================================ */
  SS.CartDrawer = {
    init() {
      const openBtn = document.querySelector('.header__cart-toggle');
      const drawer = document.querySelector('.cart-drawer');
      const closeBtn = document.querySelector('.cart-drawer__close');
      const overlay = document.querySelector('.overlay--cart');

      if (!drawer) return;

      // Ensure closed on load
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      if (openBtn) {
        openBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          SS.CartDrawer.open();
        });
      }

      if (closeBtn) closeBtn.addEventListener('click', function() { SS.CartDrawer.close(); });
      if (overlay) overlay.addEventListener('click', function() { SS.CartDrawer.close(); });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          SS.CartDrawer.close();
        }
      });
    },

    open() {
      const drawer = document.querySelector('.cart-drawer');
      const overlay = document.querySelector('.overlay--cart');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('overflow-hidden');
    },

    close() {
      const drawer = document.querySelector('.cart-drawer');
      const overlay = document.querySelector('.overlay--cart');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden');
    },

    updateCount(count) {
      const badge = document.querySelector('.header__cart-count');
      if (!badge) return;
      badge.textContent = count > 0 ? count : '';
      badge.dataset.count = count;
      if (count > 0) {
        badge.classList.remove('is-animating');
        void badge.offsetWidth;
        badge.classList.add('is-animating');
      }
    },

    async refresh() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const cart = await response.json();
        this.updateCount(cart.item_count);
        this.renderItems(cart);
      } catch (err) {
        console.error('Cart refresh failed:', err);
      }
    },

    renderItems(cart) {
      const body = document.querySelector('.cart-drawer__body');
      const footer = document.querySelector('.cart-drawer__footer');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p class="cart-drawer__empty-text">' + (window.SS_TRANSLATIONS ? window.SS_TRANSLATIONS.cart_empty : 'Your cart is empty') + '</p>' +
            '<a href="/collections/all" class="btn btn--secondary btn--sm">' + (window.SS_TRANSLATIONS ? window.SS_TRANSLATIONS.continue_shopping : 'Continue Shopping') + '</a>' +
          '</div>';
        if (footer) footer.style.display = 'none';
        return;
      }

      if (footer) footer.style.display = '';

      var html = '';
      cart.items.forEach(function(item) {
        var imageUrl = '';
        if (item.featured_image && item.featured_image.url) {
          imageUrl = item.featured_image.url;
        } else if (item.image) {
          imageUrl = item.image;
        }

        var variantTitle = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantTitle = item.variant_title;
        }

        var price = SS.Helpers.formatMoney(item.final_line_price);

        html +=
          '<div class="cart-item" data-key="' + item.key + '">' +
            (imageUrl ? '<img src="' + imageUrl + '" alt="' + item.product_title + '" class="cart-item__image" loading="lazy">' : '') +
            '<div class="cart-item__details">' +
              '<span class="cart-item__title">' + item.product_title + '</span>' +
              (variantTitle ? '<span class="cart-item__variant">' + variantTitle + '</span>' : '') +
              '<span class="cart-item__qty">Qty: ' + item.quantity + '</span>' +
              '<span class="cart-item__price">' + price + '</span>' +
              '<button class="cart-item__remove" data-remove-key="' + item.key + '" type="button">Remove</button>' +
            '</div>' +
          '</div>';
      });
      body.innerHTML = html;

      // Update subtotal
      var subtotalEl = document.querySelector('.cart-drawer__subtotal-amount');
      if (subtotalEl) {
        subtotalEl.textContent = SS.Helpers.formatMoney(cart.total_price);
      }

      // Bind remove buttons
      body.querySelectorAll('.cart-item__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          SS.CartDrawer.removeItem(this.dataset.removeKey);
        });
      });
    },

    async removeItem(key) {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        const cart = await response.json();
        this.updateCount(cart.item_count);
        this.renderItems(cart);
      } catch (err) {
        console.error('Remove item failed:', err);
      }
    }
  };

  /* ================================================
     REGION SELECTOR
     ================================================ */
  SS.Region = {
    init() {
      const wrapper = document.querySelector('.header__region-wrapper');
      if (wrapper) {
        const btn = wrapper.querySelector('.header__region-btn');

        if (btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            wrapper.classList.toggle('is-open');
          });
        }

        document.addEventListener('click', function() {
          wrapper.classList.remove('is-open');
        });

        wrapper.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    }
  };

  /* ================================================
     HEADER SCROLL BEHAVIOR
     ================================================ */
  SS.Header = {
    init() {
      const header = document.querySelector('.header-wrapper');
      if (!header) return;

      window.addEventListener('scroll', function() {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
    }
  };

  /* ================================================
     SCROLL REVEAL ANIMATIONS
     ================================================ */
  SS.ScrollReveal = {
    init() {
      const elements = document.querySelectorAll('.reveal, .reveal-stagger');
      if (!elements.length) return;

      if (document.documentElement.classList.contains('reduced-motion')) {
        elements.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -48px 0px'
      });

      elements.forEach(function(el) { observer.observe(el); });
    }
  };

  /* ================================================
     NEWSLETTER POPUP
     ================================================ */
  SS.NewsletterPopup = {
    init() {
      const popup = document.querySelector('.newsletter-popup');
      if (!popup) return;

      const storageKey = 'ss-newsletter-dismissed';
      if (localStorage.getItem(storageKey)) return;

      const delay = parseInt(popup.dataset.delay) || 25000;
      const closeBtn = popup.querySelector('.newsletter-popup__close');
      const overlayEl = popup.querySelector('.newsletter-popup__overlay');

      function show() {
        popup.classList.add('is-active');
        document.body.classList.add('overflow-hidden');
      }

      function closePopup() {
        popup.classList.remove('is-active');
        document.body.classList.remove('overflow-hidden');
        localStorage.setItem(storageKey, 'true');
      }

      setTimeout(show, delay);

      if (closeBtn) closeBtn.addEventListener('click', closePopup);
      if (overlayEl) overlayEl.addEventListener('click', closePopup);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('is-active')) {
          closePopup();
        }
      });
    }
  };

  /* ================================================
     LAZY LOAD
     ================================================ */
  SS.LazyLoad = {
    init() {
      if ('loading' in HTMLImageElement.prototype) {
        document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        });
      }
    }
  };

  /* ================================================
     KEYBOARD NAVIGATION
     ================================================ */
  SS.KeyboardNav = {
    init() {
      document.body.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
        document.body.classList.remove('using-keyboard');
      });
      document.body.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
          document.body.classList.add('using-keyboard');
          document.body.classList.remove('using-mouse');
        }
      });
    }
  };

  /* ================================================
     REDUCED MOTION
     ================================================ */
  SS.ReducedMotion = {
    init() {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      function update(e) {
        if (e.matches) {
          document.documentElement.classList.add('reduced-motion');
        } else {
          document.documentElement.classList.remove('reduced-motion');
        }
      }
      update(mq);
      mq.addEventListener('change', update);
    }
  };

  /* ================================================
     ACCESSIBILITY
     ================================================ */
  SS.Accessibility = {
    announce(message) {
      var region = document.getElementById('aria-live-region');
      if (!region) return;
      region.textContent = '';
      setTimeout(function() {
        region.textContent = message;
      }, 100);
    }
  };

  /* ================================================
     HELPERS
     ================================================ */
  SS.Helpers = {
    formatMoney(cents) {
      var amount = cents / 100;
      var region = localStorage.getItem('ss-region') || 'PH';

      // Format with proper thousand separators and decimals
      var formatted = amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      if (region === 'ES') {
        // European format: €1.234,56
        formatted = amount.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return '\u20AC' + formatted;
      }

      // PHP format: ₱1,234.56
      return '\u20B1' + formatted;
    }
  };

  /* ================================================
     INIT ALL
     ================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    SS.NotificationBar.init();
    SS.MobileMenu.init();
    SS.SearchDrawer.init();
    SS.CartDrawer.init();
    SS.Region.init();
    SS.Header.init();
    SS.ScrollReveal.init();
    SS.NewsletterPopup.init();
    SS.LazyLoad.init();
    SS.KeyboardNav.init();
    SS.ReducedMotion.init();

    SS.CartDrawer.refresh();
  });

})();